import { Group, Highlight, Stack, Text } from "@mantine/core";
import { spotlight, Spotlight } from "@mantine/spotlight";
import { generatePath, useNavigate } from "react-router";
import { useGenerator } from "../../../hooks/useGenerator";
import { ROUTES } from "../../../routes";
import type { TQuicksearchGenerator } from "../Quicksearch.types";

function QuicksearchGenerator({
  item,
  highlight = []
}: {
  item: TQuicksearchGenerator;
  highlight?: string[];
}) {
  const navigate = useNavigate();
  const { data: generator } = useGenerator(item.id);
  const idLine = [
    item.tr_id && `TR: ${item.tr_id}`,
    item.mastr_nummer && `MaStR: ${item.mastr_nummer}`
  ]
    .filter(Boolean)
    .join(" | ");

  const handleClick = () => {
    navigate(
      generatePath(ROUTES.site.generator, {
        projectId: item.project_id,
        componentId: String(item.id),
        siteId: String(item.site_id)
      })
    );
    spotlight.close();
  };

  return (
    <Group justify="space-between" key={item.name}>
      <Spotlight.Action flex={1} w="auto" onClick={handleClick}>
        <Stack gap={0}>
          <Highlight highlight={highlight}>{item.name}</Highlight>{" "}
          <Text opacity={0.6} size="xs">
            {generator?.site_name || "Lade Standort..."}
          </Text>
          {idLine && (
            <Text opacity={0.6} size="xs">
              {idLine}
            </Text>
          )}
        </Stack>
      </Spotlight.Action>
    </Group>
  );
}

export { QuicksearchGenerator };
